import { render } from "./user_card.vue?vue&type=template&id=f57a9d86"
import script from "./user_card.js?vue&type=script&lang=js"
export * from "./user_card.js?vue&type=script&lang=js"

import "./user_card.scss?vue&type=style&index=0&lang=scss"

import exportComponent from "/home/jojo/Documents/aspho-fe-pleromer/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__